import api from './api';

// Formatar moeda BRL
export const fmtMoeda = (v, negativo = false) => {
  const val = parseFloat(v) || 0;
  const fmt = val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  return negativo && val > 0 ? `-${fmt}` : fmt;
};

// Formatar data
export const fmtData = (d) => {
  if (!d) return '';
  // Extrai apenas YYYY-MM-DD para evitar problema de fuso com strings ISO completas
  const s = String(d).substring(0, 10);
  return new Date(s + 'T12:00:00').toLocaleDateString('pt-BR');
};

// Mês atual YYYY-MM
export const mesAtual = () => new Date().toISOString().substring(0, 7);

// Contas
export const ContasService = {
  listar: () => api.get('/contas').then(r => r.data),
  buscar: (id) => api.get(`/contas/${id}`).then(r => r.data),
  criar: (data) => api.post('/contas', data).then(r => r.data),
  atualizar: (id, data) => api.put(`/contas/${id}`, data).then(r => r.data),
  excluir: (id) => api.delete(`/contas/${id}`).then(r => r.data),
  extrato: (id, params) => api.get(`/contas/${id}/extrato`, { params }).then(r => r.data),
};

// Cartões
export const CartoesService = {
  listar: () => api.get('/cartoes').then(r => r.data),
  buscar: (id) => api.get(`/cartoes/${id}`).then(r => r.data),
  criar: (data) => api.post('/cartoes', data).then(r => r.data),
  atualizar: (id, data) => api.put(`/cartoes/${id}`, data).then(r => r.data),
  excluir: (id) => api.delete(`/cartoes/${id}`).then(r => r.data),
  faturas: (id) => api.get(`/cartoes/${id}/faturas`).then(r => r.data),
  fatura: (id, mes) => api.get(`/cartoes/${id}/faturas/${mes}`).then(r => r.data),
  pagarFatura: (id, mes, data) => api.post(`/cartoes/${id}/faturas/${mes}/pagar`, data).then(r => r.data),
};

// Transações
export const TransacoesService = {
  listar: (params) => api.get('/transacoes', { params }).then(r => r.data),
  saldoAnterior: (params) => api.get('/transacoes/saldo-anterior', { params }).then(r => r.data),
  criar: (data) => api.post('/transacoes', data).then(r => r.data),
  atualizar: (id, data) => api.put(`/transacoes/${id}`, data).then(r => r.data),
  excluir: (id) => api.delete(`/transacoes/${id}`).then(r => r.data),
};

// Anexos de transações
export const AnexosService = {
  listar: (transacaoId) => api.get(`/transacoes/${transacaoId}/anexos`).then(r => r.data),
  upload: (transacaoId, file) => {
    const fd = new FormData();
    fd.append('arquivo', file);
    return api.post(`/transacoes/${transacaoId}/anexos`, fd).then(r => r.data);
  },
  excluir: (id) => api.delete(`/anexos/${id}`).then(r => r.data),
  urlDownload: (id) => {
    const token = sessionStorage.getItem('cf_token') || '';
    return `/api/anexos/${id}/download?token=${encodeURIComponent(token)}`;
  },
};

// Transferências
export const TransferenciasService = {
  listar: (params) => api.get('/transferencias', { params }).then(r => r.data),
  criar: (data) => api.post('/transferencias', data).then(r => r.data),
  excluir: (id) => api.delete(`/transferencias/${id}`).then(r => r.data),
};

// Categorias
export const CategoriasService = {
  listar: (params) => api.get('/categorias', { params }).then(r => r.data),
  criar: (data) => api.post('/categorias', data).then(r => r.data),
  atualizar: (id, data) => api.put(`/categorias/${id}`, data).then(r => r.data),
  excluir: (id) => api.delete(`/categorias/${id}`).then(r => r.data),
};

// Orçamentos
export const OrcamentosService = {
  listar: (mes) => api.get('/orcamentos', { params: { mes } }).then(r => r.data),
  criar: (data) => api.post('/orcamentos', data).then(r => r.data),
  atualizar: (id, data) => api.put(`/orcamentos/${id}`, data).then(r => r.data),
  excluir: (id) => api.delete(`/orcamentos/${id}`).then(r => r.data),
};

// Metas
export const MetasService = {
  listar: () => api.get('/metas').then(r => r.data),
  criar: (data) => api.post('/metas', data).then(r => r.data),
  atualizar: (id, data) => api.put(`/metas/${id}`, data).then(r => r.data),
  excluir: (id) => api.delete(`/metas/${id}`).then(r => r.data),
  aporte: (id, data) => api.post(`/metas/${id}/aporte`, data).then(r => r.data),
  aportes: (id) => api.get(`/metas/${id}/aportes`).then(r => r.data),
};

// Recorrências
export const RecorrenciasService = {
  listar: (params) => api.get('/recorrencias', { params }).then(r => r.data),
  criar: (data) => api.post('/recorrencias', data).then(r => r.data),
  atualizar: (id, data) => api.put(`/recorrencias/${id}`, data).then(r => r.data),
  excluir: (id) => api.delete(`/recorrencias/${id}`).then(r => r.data),
  desativar: (id) => api.post(`/recorrencias/${id}/desativar`).then(r => r.data),
};

// Dashboard
export const DashboardService = {
  dados: (mes) => api.get('/dashboard', { params: { mes } }).then(r => r.data),
};

// Relatórios
export const RelatoriosService = {
  mensal: (mes) => api.get('/relatorios/mensal', { params: { mes } }).then(r => r.data),
  anual: (ano) => api.get('/relatorios/anual', { params: { ano } }).then(r => r.data),
  fluxo: (inicio, fim) => api.get('/relatorios/fluxo', { params: { inicio, fim } }).then(r => r.data),
  patrimonio: () => api.get('/relatorios/patrimonio').then(r => r.data),
};

// Sub-usuários (perfis de visualização)
export const SubUsuariosService = {
  listar: () => api.get('/sub-usuarios').then(r => r.data),
  criar: (data) => api.post('/sub-usuarios', data).then(r => r.data),
  atualizar: (id, data) => api.put(`/sub-usuarios/${id}`, data).then(r => r.data),
  excluir: (id) => api.delete(`/sub-usuarios/${id}`).then(r => r.data),
  atualizarContas: (id, conta_ids) => api.put(`/sub-usuarios/${id}/contas`, { conta_ids }).then(r => r.data),
};

// Usuário
export const UsuariosService = {
  perfil: () => api.get('/usuarios/perfil').then(r => r.data),
  atualizarPerfil: (data) => api.put('/usuarios/perfil', data).then(r => r.data),
  alterarSenha: (data) => api.put('/usuarios/senha', data).then(r => r.data),
};
